export const investmentKeys = {
  all: () => ["investment"] as const,
  list: (filters: unknown) => [...investmentKeys.all(), filters] as const,
  detail: (id: string) => [...investmentKeys.all(), id] as const,
  vault: (id: string) => [...investmentKeys.detail(id), "vault"],
  payment: (id: string, paymentId: string) => [
    ...investmentKeys.detail(id),
    "payment",
    paymentId,
  ],
};

export const offeringKeys = {
  all: () => ["offerings"] as const,
  list: () => [...offeringKeys.all()] as const,
  detail: (id: string) => [...offeringKeys.all(), id] as const,
  investments: (id: string, filters: unknown) => [
    ...offeringKeys.detail(id),
    "investments",
    filters,
  ],
};
